export const primary = 'primary';
export const secondary = 'secondary';
export const tertiary = 'tertiary';
//# sourceMappingURL=emphasis.js.map